var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container background__color--white" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-9" }, [
        _c("div", { staticClass: "checkout" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "h2",
                {
                  staticClass:
                    "heading__h2 font__family--gotham font__weight--medium font__color--gray pb-4 mb-0",
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.$t("your_data", "user_account")) +
                      "\n                        "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pb-5" }, [
            _c("div", { staticClass: "col-12 d-flex" }, [
              _c("div", { staticClass: "radio-el radio-el--invisible" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pickedPrivateOrCompany,
                      expression: "pickedPrivateOrCompany",
                    },
                  ],
                  staticClass: "radio-el__input",
                  attrs: {
                    name: "private_or_company",
                    type: "radio",
                    id: "privatePerson",
                    value: "person",
                  },
                  domProps: {
                    checked: _vm._q(_vm.pickedPrivateOrCompany, "person"),
                  },
                  on: {
                    change: function ($event) {
                      _vm.pickedPrivateOrCompany = "person"
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass:
                      "radio-el__label d-flex justify-content-between align-items-center pl-0 pr-5",
                    attrs: { for: "privatePerson" },
                  },
                  [
                    _c("span", { staticClass: "d-flex align-items-center" }, [
                      _c("span", { staticClass: "checkmark mr-4" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "radio-el__label__text font__family--gotham font__weight--medium font__color--gray",
                        },
                        [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(_vm.$t("person", "user_account")) +
                              "\n                                    "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio-el radio-el--invisible" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pickedPrivateOrCompany,
                      expression: "pickedPrivateOrCompany",
                    },
                  ],
                  staticClass: "radio-el__input",
                  attrs: {
                    name: "private_or_company",
                    type: "radio",
                    id: "companyPerson",
                    value: "company",
                  },
                  domProps: {
                    checked: _vm._q(_vm.pickedPrivateOrCompany, "company"),
                  },
                  on: {
                    change: function ($event) {
                      _vm.pickedPrivateOrCompany = "company"
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass:
                      "radio-el__label d-flex justify-content-between align-items-center pl-4 pr-0",
                    attrs: { for: "companyPerson" },
                  },
                  [
                    _c("span", { staticClass: "d-flex align-items-center" }, [
                      _c("span", { staticClass: "checkmark mr-4" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "radio-el__label__text font__family--gotham font__weight--medium font__color--gray",
                        },
                        [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(_vm.$t("company", "user_account")) +
                              "\n                                    "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.pickedPrivateOrCompany === "person"
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("simple-data", {
                      ref: "simple_data_validate",
                      attrs: { name: "simple-data" },
                      model: {
                        value: _vm.simple_data,
                        callback: function ($$v) {
                          _vm.simple_data = $$v
                        },
                        expression: "simple_data",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pickedPrivateOrCompany === "company"
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("company-data", {
                      ref: "company_data_validate",
                      attrs: { name: "company" },
                      model: {
                        value: _vm.company_data,
                        callback: function ($$v) {
                          _vm.company_data = $$v
                        },
                        expression: "company_data",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pb-5" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "h4",
                  {
                    staticClass:
                      "heading__h4 font__family--gotham font__weight--medium font__color--gray pb-4 mb-0",
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("address_data", "user_account")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("shipment-data", {
                  ref: "billing_data_validate",
                  attrs: { name: "bilings" },
                  model: {
                    value: _vm.billings_data,
                    callback: function ($$v) {
                      _vm.billings_data = $$v
                    },
                    expression: "billings_data",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pb-5" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "h4",
                  {
                    staticClass:
                      "heading__h4 font__family--gotham font__weight--medium font__color--gray pb-2 mb-0",
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("password", "form_passwords"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("user-passwords", {
                  ref: "passwords_validate",
                  attrs: { name: "password" },
                  model: {
                    value: _vm.passwords,
                    callback: function ($$v) {
                      _vm.passwords = $$v
                    },
                    expression: "passwords",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("acceptances", {
                  ref: "acceptance_validate",
                  attrs: {
                    name: "acceptance",
                    terms_obj: _vm.$t("register_user", "acceptance"),
                  },
                  model: {
                    value: _vm.acceptance,
                    callback: function ($$v) {
                      _vm.acceptance = $$v
                    },
                    expression: "acceptance",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              !_vm.register_user_info.success
                ? _c(
                    "p",
                    {
                      staticClass:
                        "heading__desc font__family--gotham font__weight--light font__color--error py-4 mb-0",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.register_user_info.data) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.register_user_info.success
                ? _c(
                    "p",
                    {
                      staticClass:
                        "heading__desc font__family--gotham font__weight--light font__color--gray py-4 mb-0",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t("userAccountSuccessInfo", "user_account")
                          ) +
                          " "
                      ),
                      _c("a", { attrs: { href: "/my-account/" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("go_to_my_account", "user_account"))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 d-flex flex-wrap flex-sm-nowrap justify-content-center",
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "button button__size-2 button__font--size-1 button__bg--gray text-center mr-sm-3 order-2 order-sm-1 mt-4 mt-sm-0",
                    attrs: { href: _vm.my_account_link },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font__family--gotham font__weight--medium font__color--white",
                      },
                      [_vm._v(_vm._s(_vm.$t("cancel", "user_account")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "button button__size-2 button__font--size-1 button__bg--dark text-center ml-sm-3 order-1 order-sm-2 mb-2 mb-sm-0",
                    class: { "button__bg--blue btn-loader": _vm.btn_loader },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.register_user.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font__family--gotham font__weight--medium font__color--white",
                      },
                      [_vm._v(_vm._s(_vm.$t("register", "user_account")))]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }